import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BlogService } from '../../../services/blog.service';
import { BlogPost } from '../../../models/blog-post.models';
import { RESPONSE } from '../../../../express.token';

export interface BlogDetailResolved {
  post: BlogPost | null;
  error?: 'notFound' | 'serverError';
}

function markResponse(res: any | undefined, status: number) {
  if (!res) return;
  try {
    res.status(status);
    res.setHeader?.('Cache-Control', 'no-store');
    res.setHeader?.('X-Robots-Tag', 'noindex, follow');
  } catch {}
}

export const blogDetailResolver: ResolveFn<BlogDetailResolved> = (route: ActivatedRouteSnapshot) => {
  const blogService = inject(BlogService);
  const res = inject(RESPONSE, { optional: true });

  const slug = route.paramMap.get('slug') ?? '';

  if (!slug) {
    // Ungültige URL -> 404
    markResponse(res, 404);
    return of({ post: null, error: 'notFound' });
  }

  return blogService.getBlogPostBySlug(slug).pipe(
    map((post) => ({ post } as BlogDetailResolved)),
    catchError((err) => {
      if (err?.status === 404) {
        markResponse(res, 404);
        return of({ post: null, error: 'notFound' } as BlogDetailResolved);
      }
      // Sonstige Fehler -> 500
      markResponse(res, 500);
      return of({ post: null, error: 'serverError' } as BlogDetailResolved);
    })
  );
};